var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraftOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3232 11.0447V10.0447C20.3232 6.27368 20.3232 4.38768 19.0832 3.21668C17.8412 2.04468 15.8452 2.04468 11.8532 2.04468H10.7932C6.80024 2.04468 4.80324 2.04468 3.56324 3.21668C2.32324 4.38868 2.32324 6.27368 2.32324 10.0447V14.0447C2.32324 17.8157 2.32324 19.7017 3.56324 20.8727C4.80324 22.0437 6.80124 22.0447 10.7932 22.0447H11.3232M7.32324 7.04468H15.3232M7.32324 12.0447H15.3232M21.1832 14.4847L21.8782 15.1767C22.0178 15.3158 22.1286 15.481 22.2042 15.663C22.2798 15.845 22.3187 16.0401 22.3187 16.2372C22.3187 16.4342 22.2798 16.6294 22.2042 16.8113C22.1286 16.9933 22.0178 17.1586 21.8782 17.2977L18.2402 20.9937C17.954 21.2793 17.5879 21.4714 17.1902 21.5447L14.9362 22.0327C14.8545 22.0508 14.7694 22.0481 14.689 22.0247C14.6085 22.0014 14.5352 21.9583 14.4758 21.8992C14.4163 21.8402 14.3727 21.7672 14.3488 21.6869C14.325 21.6066 14.3217 21.5216 14.3392 21.4397L14.8192 19.2047C14.8932 18.8077 15.0862 18.4427 15.3732 18.1577L19.0562 14.4837C19.3387 14.2023 19.7211 14.0444 20.1197 14.0444C20.5184 14.0444 20.9008 14.2033 21.1832 14.4847Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftOrderIcon);
export default __webpack_public_path__ + "static/media/draftOrder-icon.f0204d925f1abab4cc67aa0915709a84.svg";
export { ForwardRef as ReactComponent };